<ng-template #loading class="d-flex justify-content-center align-items-center h-100 w-100 pt-4">
  <mat-spinner class="mt-4 loading-spinner"></mat-spinner>
</ng-template>

<ng-container *ngIf="!(loading$ | async) && (proposal$|async) as proposal;else loading">
  <div [class.create-offer]="createOfferStyle"
       class="w-100 d-flex flex-row justify-content-between align-items-center button-container">

    <div class="open-details d-flex ">
      <span class="open-all-label">
        {{(!allDetailsOpen ? 'createOffer.openDetails' : 'createOffer.closeDetails') | translate}}
      </span>
      <mat-slide-toggle class="ms-2" [(ngModel)]="allDetailsOpen" id="slide-toggle"></mat-slide-toggle>
    </div>

    <div class="d-flex justify-content-between">

      <button *ngIf="
        !isPreview &&
        !createOfferStyle &&
        ProposalStatus.RETRACTED != proposal.proposalInformation.status &&
        (user$|async)?.id == proposal.creator.id &&
        (proposalTile$|async) as proposalTile"

        class="blue-border share-button me-3"
          (click)="openShareProposalPDFDialog(proposal, proposalTile)"
              [class]="proposal.proposalInformation.emailsReceivedPDFWithDate?.length>0 ? 'active' : ''"
          matTooltip="{{'shareProposalPDFDialog.buttonLabel' | translate}}"
          [matTooltipShowDelay]="1000"
      >
        <img class="icon" alt="" [src]="proposal.proposalInformation.emailsReceivedPDFWithDate?.length>0 ? 'assets/svg-icons/send-active.svg' : 'assets/svg-icons/send.svg'">
        {{'shareProposalPDFDialog.buttonLabel' | translate}}
      </button>

      <button *ngIf="!(isExternalCoverage || isPreview || createOfferStyle)" class="blue-border note-button me-3"
          (click)="openPrivateNoteDialog()"
          [class]="(privateNote$|async)?.note ? 'active' : ''"
          matTooltip="{{'proposalDetails.privateNote' | translate}}"
          [matTooltipShowDelay]="1000">
        <img class="icon" alt="" [src]="(privateNote$|async)?.note ? 'assets/svg-icons/comment-active.svg' : 'assets/svg-icons/comment.svg'">
      </button>

      <button *ngIf="
        ProposalStatus.RETRACTED != proposal.proposalInformation.status &&
        (user$|async)?.id == proposal.creator.id"

      class="blue-border edit-button me-3"
        (click)="editProposalClick(proposal)">
        <img class="icon" alt="" [src]="'assets/svg-icons/refill-circle.svg'">
        {{'editProposal.name'|translate}}
      </button>

      <button
        *ngIf="!isPreview && ProposalStatus.RETRACTED != proposal.proposalInformation.status && (user$|async)?.id == proposal.creator.id && !isExternalCoverage && proposal.proposalInformation.deadline > Date.now()"
        class="retract-button"
        (click)="retractOfferClick(proposal)">
        <img alt="" src="assets/svg-icons/retract-arrow.svg" class="me-2">
        {{'retractProposal'|translate}}
      </button>
    </div>

  </div>
  <mat-accordion [multi]="true" displayMode="flat" class="accordion-container">

    <!-- Partner information -->
    <mat-expansion-panel [disabled]="disablePartnerInfo$|async" [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          {{'proposalDetails.partnerInformation' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-insurance-contract-detail-partner-info
        [proposal]="proposal"></app-insurance-contract-detail-partner-info>
    </mat-expansion-panel>

    <hr>
    <!-- Risk details     -->
    <mat-expansion-panel [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          {{'proposalDetails.theRisk' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-insurance-contract-detail-risk-info
        [proposal]="proposal"></app-insurance-contract-detail-risk-info>
    </mat-expansion-panel>

    <hr>
    <!-- Insured sum-->
    <mat-expansion-panel [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          {{'proposalDetails.sums' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-insurance-contract-detail-sum-insureds
        [proposal]="proposal"></app-insurance-contract-detail-sum-insureds>
    </mat-expansion-panel>
    <hr>
    <!-- Risk description -->
    <mat-expansion-panel [disabled]="proposal.proposalInformation.riskDescriptionFreeText === null || proposal.proposalInformation.riskDescriptionFreeText === ''" [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          {{'proposalDetails.riskDescription' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-insurance-contract-detail-risk-description
        [proposal]="proposal"></app-insurance-contract-detail-risk-description>
    </mat-expansion-panel>
    <hr>
    <!-- Risk locations -->
    <mat-expansion-panel [disabled]="proposal.riskLocations.length == 0" [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          {{'proposalDetails.riskLocation' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-insurance-contract-detail-risk-locations
        [proposal]="proposal"></app-insurance-contract-detail-risk-locations>
    </mat-expansion-panel>
    <hr>
    <!-- international Program needed -->
    <mat-expansion-panel [disabled]="proposal.proposalInformation.countriesWithLocalPolicies == null || proposal.proposalInformation.countriesWithLocalPolicies?.length  == 0"
                         [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          {{'proposalDetails.internationalPrograms' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-proposal-detail-international-program
        [proposal]="proposal"></app-proposal-detail-international-program>
    </mat-expansion-panel>
    <hr>
    <!-- Previous damage -->
    <mat-expansion-panel [disabled]="proposal.previousDamages.length === 0" [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          {{'proposalDetails.previousDamages' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-insurance-contract-detail-previous-damages
        [insuranceContract]="proposal"></app-insurance-contract-detail-previous-damages>
    </mat-expansion-panel>

    <hr>
    <!-- Individual Claims and Conditions -->
    <mat-expansion-panel
      [disabled]="
    (proposal.proposalInformation.individualConditionsFreeText === null || proposal.proposalInformation.individualConditionsFreeText === '') &&
    (proposal.proposalInformation.individualClausesFreeText === null || proposal.proposalInformation.individualClausesFreeText === '')"
         [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          {{'proposalDetails.individualClausesConditions' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-insurance-contract-detail-individual-clauses-conditions
        [proposal]="proposal"></app-insurance-contract-detail-individual-clauses-conditions>
    </mat-expansion-panel>

    <hr>
    <!-- Proposal information -->
    <mat-expansion-panel [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          {{'proposalDetails.proposalInformation' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-insurance-contract-detail-advertisement-info
        [insuranceContract]="proposal" [usersAllowedToView]="usersAllowedToView"></app-insurance-contract-detail-advertisement-info>
    </mat-expansion-panel>

    <hr>
    <mat-expansion-panel
      [disabled]="proposal.proposalInformation.attachedFiles.length == 0"
      [togglePosition]="'before'"
      [ngClass]="{'mb-4': !createOfferStyle}">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          {{'proposalDetails.files' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-proposal-details-download
        [proposal]="proposal"></app-proposal-details-download>
    </mat-expansion-panel>
    <div *ngIf="createOfferStyle">
    <hr>
    <mat-expansion-panel [togglePosition]="'before'"
                         [disabled]="proposal?.leadingOfferInfo == null"
                         class="mb-4">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          {{'proposalDetails.leadingOffer' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-leading-offer-tab [leadingOfferInfo]="proposal?.leadingOfferInfo" class="w-100"></app-leading-offer-tab>
    </mat-expansion-panel>
    </div>
  </mat-accordion>

</ng-container>

